import React from 'react';
import { components, typography } from '../utils/designTokens';

/**
 * Stat - Individual stat item showing label and value
 * Used within StatsBar to display entity counts and metadata
 */
const Stat = ({ label, value }) => {
  if (!label) throw new Error('Stat requires label prop');
  if (value === undefined || value === null) throw new Error('Stat requires value prop');

  return (
    <span className="text-xs whitespace-nowrap" style={{ color: components.table.cell.colors.time }}>
      {label} (<span className={typography.weight.semibold}>{value}</span>)
    </span>
  );
};

export default Stat;
